export default {
    init: function ( $element ) {
        "use strict";
        var _this = this;

        _this.$sidebar = $element.find("#rightsidebar");
        _this.$overlay = $element.find(".overlay");
        _this.$rightSidebar = $element.find(".right-sidebar");
        _this.$rightSidebarBtn = $element.find(".js-right-sidebar");

        return _this;
    },

    activate: function () {
        "use strict";
        var _this = this;

        //Close sidebar
        $(window).click(function (e) {
            var $target = $(e.target);

            if (e.target.nodeName.toLowerCase() === "i") {
                $target = $(e.target).parent();
            }

            if (!$target.hasClass("js-right-sidebar") && _this.isOpen() && $target.parents("#rightsidebar").length === 0) {
                if (!$target.hasClass("bars")) {
                     _this.$overlay.fadeOut();
                }

                 _this.$sidebar.removeClass("open");
            }
        });

        _this.$rightSidebarBtn.on("click", function () {
            _this.$sidebar.toggleClass("open");
            var $li = _this.$sidebar.find( ".demo-choose-skin li" );

            // Set defualt theme
            $li.each( function ( index, el ) {
                var attrValue = $( el )
                    .attr( "data-theme" );
                $( el ).removeClass( "active" );
                if ( attrValue === Vistracks.Scope.AppState.attr( "themeColor" ).split( /-(.+)/ )[ 1 ] ) {
                    $( el )
                        .addClass( "active" );
                }
            } );

            if (_this.isOpen()) {
                _this.$overlay.fadeIn();
            } else {
                _this.$overlay.fadeOut();
            }
        });
    },

    isOpen: function () {
        "use strict";
        var _this = this;
        return _this.$rightSidebar.hasClass("open");
    }
};
